import { observer } from "mobx-react-lite";
import { FC } from "react";
import { useAppBannerLinkOnClickHandler } from "@/components/banners/app-callout-banner/utils/app-banner-link-handling";
import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";

interface AppCalloutBannerInlineActionProps {
  label: string | null;
  url: string | null;
}

export const AppCalloutBannerInlineAction: FC<AppCalloutBannerInlineActionProps> = observer(
  ({ label, url }) => {
    if (!label) return null;
    if (!url) return null;

    const { onClickHandler } = useAppBannerLinkOnClickHandler({ url });

    return (
      <InlineActionText
        variant={MDSTextVariant.TextS}
        weight={MDSTextWeight.Regular}
        onClick={onClickHandler}
      >
        {label}
      </InlineActionText>
    );
  }
);

const InlineActionText = styled(MDSText)({
  display: "inline",
  marginLeft: "4px",
});
